// Shared merchant-rule matcher. CommonJS so server/parsers.js can require() it
// and CRA can import it — react-scripts 5 forbids client imports from outside
// client/src, so this is the one location both sides can reach.
//
// The view is a PARAMETER, never derived in here. The server resolves it from
// the accounts registry and the client from isBusinessAccount(); baking an
// account list into this file is what let the two disagree.

// Three live keywords carry regex metacharacters — 'apple.com/bill',
// 'intuit *qbooks', 'intuit *turbotax'. A bare '*' throws with nothing to quantify.
const escapeRegex = s => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

// Word boundaries, or 'fee' matches inside 'coffee' — 52 of 59 real matches
// were cafés before this landed.
function keywordMatches(desc, keyword) {
  const d = String(desc).toLowerCase();
  try {
    return new RegExp('\\b' + escapeRegex(String(keyword).toLowerCase()) + '\\b', 'i').test(d);
  } catch {
    // A malformed stored keyword shouldn't take an entire import down with it.
    return d.includes(String(keyword).toLowerCase());
  }
}

// The first rule wins, in the caller's order (created_at). Returns the rule
// object itself, not just its category, so callers can show which one matched.
// A rule with no view predates the column and stays global.
function findMatchingRule(desc, rules, view) {
  for (const rule of rules || []) {
    if (rule.view && rule.view !== view) continue;
    if (keywordMatches(desc, rule.keyword)) return rule;
  }
  return null;
}

module.exports = { escapeRegex, keywordMatches, findMatchingRule };
